/** Abaixo disso, a leitura da placa vale a pena conferir manualmente antes de
 *  confiar cegamente (ex.: acionar uma multa automática). Sem base estatística
 *  ainda — ajustar conforme o volume real de leituras em produção. */
export const LOW_CONFIDENCE_THRESHOLD = 70

export const isLowConfidence = (confidenceLevel: number | null): boolean =>
  confidenceLevel !== null && confidenceLevel < LOW_CONFIDENCE_THRESHOLD
